import initialState from './initial-state'
import * as ACTIONS from 'constant/actions/auth'
import permissions from 'common/constant/user-permissions-obj'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.AUTH_USER_LOGIN + '_PENDING':
      state = {
        ...state,
        loggingIn: true
      }
      break
    case ACTIONS.AUTH_USER_LOGIN + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          authed: action.payload.data.authed,
          loggingIn: false,
          loginMessage: action.payload.data.message || '',
          userData: action.payload.data.user || {
            permissions
          }
        }
      } else {
        state = {
          ...state,
          loggingIn: false
        }
      }
      break
    case ACTIONS.AUTH_CHECK_STATUS + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          authed: action.payload.data.authed,
          userData: action.payload.data.user || {
            permissions
          }
        }
      }
      break
    case ACTIONS.AUTH_USER_LOGOUT + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          authed: false,
          userData: {
            permissions
          }
        }
      }
  }
  return state
}
